import React from 'react';
import Hero from '../components/hero';
import NavBar from '../components/navbar';
import { bannerImages, categories, logo, products } from '../constant';
import Footer from './footer';
import Product from '../components/product'
export default function HomePage() {
  return (
    <div className='bg-white p-2 sm:p-1 '>
      <NavBar logo={logo.image} />
      <div className='flex flex-row mt-0 sm:mt-10 p-0 sm:p-4'>
        <div className='w-52  hidden sm:block  items-center place-content-center rounded-sm'>
          <ul className='flex-col'>
            {categories.map(c => (
              <li key={c.id} className='w-full cursor-pointer text-center p-4 border btn-square rounded-sm '>
                {c.name}
              </li>))}
          </ul>
        </div>
        <Hero images={[bannerImages.lg.image]} />
      </div>
      <div className='grid grid-cols-2 sm:grid-cols-3 gap-4 pr-4 sm:ml-52 mt-6 sm:mt-0 '>
        {
          products.map(p => (<Product product={p}/> ))
        }
      </div>
      <Footer />
    </div>
  )
}
